import { __rest as e } from "tslib";
import * as a from "react";
import r from "classnames";
import { classNameModifier as o, classNameModifierByFlag as l } from "../shared/utils.js";
import { ComponentClassNames as t } from "../shared/constants.js";
import { Flex as i } from "../Flex/Flex.js";
import { View as s } from "../View/View.js";
import { IconExpandMore as c } from "../Icon/icons/IconExpandMore.js";
var m = a.forwardRef(function (m, n) {
  var d = m.autoComplete,
      p = m.className,
      u = m.size,
      f = m.variation,
      v = m.value,
      h = m.defaultValue,
      E = m.hasError,
      _m$icon = m.icon,
      S = _m$icon === void 0 ? a.createElement(c, null) : _m$icon,
      j = m.iconColor,
      C = m.children,
      N = m.placeholder,
      b = m.isDisabled,
      V = m.isRequired,
      x = e(m, ["autoComplete", "className", "size", "variation", "value", "defaultValue", "hasError", "icon", "iconColor", "children", "placeholder", "isDisabled", "isRequired"]);
  var q = void 0 === v && void 0 === h && N,
      w = r(t.Select, t.FieldGroupControl, o(t.Select, u), o(t.Select, f), l(t.Select, "error", E), p);
  return a.createElement(s, {
    className: t.SelectWrapper
  }, a.createElement(s, Object.assign({
    "aria-invalid": E,
    as: "select",
    autoComplete: d,
    value: v,
    defaultValue: q ? "" : h,
    isDisabled: b,
    required: V,
    "data-size": u,
    "data-variation": f,
    className: w,
    ref: n
  }, x), N && a.createElement("option", {
    value: ""
  }, N), C), a.createElement(i, {
    className: t.SelectIconWrapper,
    color: j
  }, S));
});
m.displayName = "Select";
export { m as Select };